import { FC } from 'react'
import { Button } from '@mui/material'

export interface AIAnnotationEditorModeButtonProps {
  label: string
  isSelected: boolean
  onClick: () => void
}

export const AIAnnotationEditorModeButton: FC<AIAnnotationEditorModeButtonProps> = ({ label, isSelected, onClick }) => {
  return (
    <Button disableRipple variant={isSelected ? 'contained' : 'outlined'} onClick={onClick}>
      {label}
    </Button>
  )
}
